import { render, staticRenderFns } from "./CampaignModal.vue?vue&type=template&id=89e2bcba&scoped=true&"
import script from "./CampaignModal.vue?vue&type=script&lang=js&"
export * from "./CampaignModal.vue?vue&type=script&lang=js&"
import style0 from "./CampaignModal.vue?vue&type=style&index=0&id=89e2bcba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e2bcba",
  null
  
)

export default component.exports